import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useMemo, useCallback } from 'react';

import { usePlayerFields } from 'js/hooks/usePlayerFields';
import { useAppSelector } from 'js/store/hooks';

import * as server from '../server';
import * as actions from '../store/actions';
import { parseUserDetails } from '../helpers';

export const useFetchParams = () => {
    const { networkType, displayPlayer } = useAppSelector(prop('leaderboard')) || {};

    return useMemo(() => {
        const networkTypes = displayPlayer === 'nicknameByNetworkType' && networkType ? [networkType] : null;
        const networkDataFilters = networkTypes ? [1, 2, 3] : null;

        return { networkTypes, networkDataFilters };
    }, [networkType, displayPlayer]);
};

export const useFetchUserDetails = () => {
    const dispatch = useDispatch();
    const { networkTypes, networkDataFilters } = useFetchParams();
    const defaultPlayerFields = usePlayerFields();

    return useCallback(async (playerFields = []) => {
        const fields = playerFields.length ? playerFields : defaultPlayerFields;
        const response = await server.fetchUserDetails(fields, networkTypes, networkDataFilters);
        const data = parseUserDetails(response.data);

        dispatch(actions.setDetails(data));

        return data;
    }, [networkTypes, networkDataFilters, dispatch, defaultPlayerFields]);
};
